import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to open the company list in the sidepanel, it also dispatches an event each time the selection
// changes.
export default class extends Controller {
  static get values() {
    return {
      url: String,
      selectedDomainIds: { type: Array, default: [] },
    }
  }

  static get targets() {
    return ["loadingTemplate", "sidepanel", "row"]
  }

  setForm() {
    if (this.rowTargets.length === 0) {
      return
    }

    TempFormHelper.create(
      this.urlValue,
      "post",
      (form) => {
        if (this.selectedDomainIdsValue.length > 0) {
          this.selectedDomainIdsValue.forEach((domainId) => {
            TempFormHelper.addHiddenInput(form, "id[]", domainId)
          })
        }
      },
      this.sidepanelTarget,
    ).requestSubmit()
  }

  _selectedDomains() {
    return this.rowTargets.reduce((hash, row) => {
      if (this.selectedDomainIdsValue.includes(row.dataset.domainId)) {
        hash[row.dataset.domainName] = row.dataset.companyName
      }
      return hash
    }, {})
  }

  // This action is used to update the selected domains value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.dataSets) {
      this.selectedDomainIdsValue = event.detail.dataSets.map((dataSet) => dataSet.domainId).filter(Boolean)
    } else {
      this.selectedDomainIdsValue = []
    }

    this.dispatch("selectionChanged", { detail: { selectedDomains: this._selectedDomains() } })
  }
}
